export default "__VITE_ASSET__Dll6Ysiw__"